<template>
  <section @contextmenu.prevent>
    <ServiceMaintenance v-if="serverError" />
    <div v-else class="main-container">
      <NewsMain @onFetchStatus="onFetchStatus" />
      <DesktopContainer />
    </div>
    <Footer />
  </section>
</template>

<script>
import NewsMain from "../components/news/NewsMain"
import DesktopContainer from "../components/DesktopContainer"
import ServiceMaintenance from "../components/ServiceMaintenance"
import Footer from "../components/Footer"

export default {
  components: {
    NewsMain,
    DesktopContainer,
    ServiceMaintenance,
    Footer
  },
  data() {
    return {
      serverError: false
    }
  },
  created() {
    this.pageViewCount()
  },
  methods: {
    isToday() {
      const TODAY = "TODAY"
      const savedDate = localStorage.getItem(TODAY)
      const today = new Date().toDateString()

      if (today === savedDate) {
        return true
      }

      localStorage.setItem(TODAY, today)
      return false
    },
    pageViewCount() {
      const PAGE_VIEW_COUNT = "PAGE_VIEW_COUNT"
      let pageViewCount = localStorage.getItem(PAGE_VIEW_COUNT) || 0
      if (!this.isToday()) {
        pageViewCount = 0
      }
      pageViewCount = +pageViewCount + 1
      localStorage.setItem(PAGE_VIEW_COUNT, pageViewCount)
      if (pageViewCount > 30) {
        pageViewCount = "30~"
      }
      gtag("event", "page-view-count", { page_view_count: pageViewCount })
    },
    onFetchStatus(status) {
      this.serverError = !status
    }
  }
}
</script>
<style lang="scss" scoped>
.main-container {
  display: flex;
  flex-direction: column;
  max-width: $desktop-width;
  margin: auto;

  @include desktop {
    flex-direction: row;
    :nth-child(1) {
      max-width: 720px;
    }
  }
}
</style>
